import { Component, OnInit } from '@angular/core';
import {trigger,state,style,animate,transition} from '@angular/animations';
import { NavController,IonRouterOutlet } from '@ionic/angular';
import { AngularFireDatabase } from '@angular/fire/database';

@Component({
  selector: 'app-info',
  templateUrl: './info.page.html',
  styleUrls: ['./info.page.scss'],
  animations: [
    trigger('elementState', [
      state('open', style({
        'max-height': '500px'
      })),
      state('closed', style({
        'max-height': 0
      })),
      transition('open => closed', animate('0ms')),
      transition('closed => open', animate('600ms'))
    ])
  ]
})
export class InfoPage implements OnInit {
  state = false;
  qnadata: any;
  cangoback:boolean = false;
  constructor(private navCtrl:NavController,
    public afDB:AngularFireDatabase,
    private outlet: IonRouterOutlet) { }

  close(){
    if(this.cangoback) this.navCtrl.pop()
    else this.navCtrl.navigateBack('/'); 
  }
  
  ngOnInit() {

    /*
    this.afDB.database.ref('/userProfile')
    .orderByChild('appver')
    .startAt('1.2.1')
    .endAt('1.7.1')
    .limitToFirst(10)
    .once('value')
    .then(rst=>{
      let data = [];
      rst.forEach(r=>{
        let user = r.val();
        data.push(user)
      })
      console.table(data);
    })
    */
/*
    this.afDB.database.ref('/category/-LZhq_q-3Nxjhca5kQ8i').once('value').then(rst=>{
      let data = rst.val()
      this.afDB.database.ref('/category/-Lj_1OCU2fkyCarAzIxD').set(data)
    })
    
    this.afDB.database.ref('/category/-LZlOkKnXKkgkqfCGuYP').once('value').then(rst=>{
      let data = rst.val()
      this.afDB.database.ref('/category/-Lj_1R4zgnl5Ogjc8z0S').set(data)
    })

    this.afDB.database.ref('/category/-LZlRs1JmeYY6_M20Tns').once('value').then(rst=>{
      let data = rst.val()
      this.afDB.database.ref('/category/-Lj_1U2ciqwlrGYLH8JN').set(data)
    })
  */  
    
    


    this.cangoback = this.outlet && this.outlet.canGoBack();
    // this.afDB.database.ref('/appqna/' + this.gv.loc + '_' + this.gv.lan).once('value').then(data=>{
    //     this.qnadata = data.val();
    // })
    this.qnadata = [
      {
        q: '채널 환전의 장점은?',
        a: '빠르고 간편합니다.'
      },
      {
        q: '수취인 실명인증 절차는 어떻게 되나요?',
        a: '준비중입니다.'
      },
      {
        q: '송금인 정보 변경 방법은?',
        a: '준비중입니다.'
      },
      {
        q: '환불은 어떻게 하나요?',
        a: '준비중입니다.'
      }
    ]
  };
  


  itemclick(no) {
    // console.log(quest);
    for (let i = 0; i < this.qnadata.length; i++) {
      if (i == no) {
        this.qnadata[i].open = !this.qnadata[i].open;
      } else {
        this.qnadata[i].open = false;
      }
    }
  }

}
